export default {
  zh: {
    brandManage: {
      title: '品牌管理',
      addBrand: '添加品牌',
      editBrand: '编辑品牌',
      brandName: '品牌名称',
      brandNamePlaceholder: '请输入品牌名称',
      brandNameRequired: '品牌名称不能为空',
      brandLogo: '品牌Logo',
      brandDesc: '品牌描述',
      brandDescPlaceholder: '请输入品牌描述',
      phone: '联系电话',
      phonePlaceholder: '请输入联系电话',
      communityName: '小区名称',
      communityNamePlaceholder: '请选择小区',
      sort: '排序',
      sortPlaceholder: '请输入排序',
      state: '状态',
      statePlaceholder: '请选择状态',
      stateOff: '未上架',
      stateOn: '上架',
      loadFailed: '加载品牌失败',
      saveFailed: '保存品牌失败',
      deleteConfirm: '确定要删除该品牌吗？',
      deleteFailed: '删除品牌失败'
    }
  },
  en: {
    brandManage: {
      title: 'Brand Management',
      addBrand: 'Add Brand',
      editBrand: 'Edit Brand',
      brandName: 'Brand Name',
      brandNamePlaceholder: 'Please enter brand name',
      brandNameRequired: 'Brand name cannot be empty',
      brandLogo: 'Brand Logo',
      brandDesc: 'Brand Description',
      brandDescPlaceholder: 'Please enter brand description',
      phone: 'Contact Phone',
      phonePlaceholder: 'Please enter contact phone',
      communityName: 'Community Name',
      communityNamePlaceholder: 'Please select community',
      sort: 'Sort',
      sortPlaceholder: 'Please enter sort',
      state: 'Status',
      statePlaceholder: 'Please select status',
      stateOff: 'Off Shelf',
      stateOn: 'On Shelf',
      loadFailed: 'Failed to load brands',
      saveFailed: 'Failed to save brand',
      deleteConfirm: 'Are you sure to delete this brand?',
      deleteFailed: 'Failed to delete brand'
    }
  }
};
 export const messages = {
  en: {
    brandManage: {
      searchCondition: 'Search Condition',
      brandIdPlaceholder: 'Please enter brand ID',
      brandNamePlaceholder: 'Please enter brand name',
      statePlaceholder: 'Please select status',
      stateOffShelf: 'Off Shelf',
      stateOnShelf: 'On Shelf',
      brandManage: 'Brand Management',
      addBrand: 'Add Brand',
      brandLogo: 'Brand Logo',
      brandName: 'Brand Name',
      brandDesc: 'Brand Description',
      sort: 'Sort',
      state: 'Status',
      offShelf: 'Off Shelf',
      onShelf: 'On Shelf'
    },
    addBrand: {
      brandName: 'Brand Name',
      brandNamePlaceholder: 'Required, please enter brand name',
      brandLogo: 'Brand Logo',
      brandLogoPlaceholder: 'Please upload brand logo',
      brandDesc: 'Brand Description',
      brandDescPlaceholder: 'Please enter brand description',
      phone: 'Contact Phone',
      phonePlaceholder: 'Please enter contact phone',
      communityName: 'Community Name',
      communityNamePlaceholder: 'Please select community',
      sort: 'Sort',
      sortPlaceholder: 'Please enter sort',
      state: 'Status',
      statePlaceholder: 'Please select status',
      offShelf: 'Off Shelf',
      onShelf: 'On Shelf',
      brandNameRequired: 'Brand name is required',
      brandNameMaxLength: 'Brand name cannot exceed 100 characters',
      sortRequired: 'Sort is required',
      sortNumber: 'Sort must be a number'
    },
    deleteBrand: {
      confirmTitle: 'Please confirm your operation!',
      confirmContent: 'Confirm to delete brand'
    }
  },
  zh: {
    brandManage: {
      searchCondition: '查询条件',
      brandIdPlaceholder: '请输入品牌ID',
      brandNamePlaceholder: '请输入品牌名称',
      statePlaceholder: '请选择状态',
      stateOffShelf: '未上架',
      stateOnShelf: '上架',
      brandManage: '品牌管理',
      addBrand: '添加品牌',
      brandLogo: '品牌Logo',
      brandName: '品牌名称',
      brandDesc: '品牌描述',
      sort: '排序',
      state: '状态',
      offShelf: '未上架',
      onShelf: '上架'
    },
    addBrand: {
      brandName: '品牌名称',
      brandNamePlaceholder: '必填，请填写品牌名称',
      brandLogo: '品牌Logo',
      brandLogoPlaceholder: '请上传品牌Logo',
      brandDesc: '品牌描述',
      brandDescPlaceholder: '请填写品牌描述',
      phone: '联系电话',
      phonePlaceholder: '请填写联系电话',
      communityName: '小区名称',
      communityNamePlaceholder: '请选择小区',
      sort: '排序',
      sortPlaceholder: '请填写排序',
      state: '状态',
      statePlaceholder: '请选择状态',
      offShelf: '未上架',
      onShelf: '上架',
      brandNameRequired: '品牌名称不能为空',
      brandNameMaxLength: '品牌名称不能超过100个字符',
      sortRequired: '排序不能为空',
      sortNumber: '排序必须是数字'
    },
    deleteBrand: {
      confirmTitle: '请确认您的操作!',
      confirmContent: '确定删除品牌'
    }
  }
}